import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ContactPaymentDetailsPage.InfoPanel.PaymentDetails', {
    title: 'Payment details',
    default: 'Default',
    bankAccountCountry: 'Сountry',
    bankAccountName: 'Account name',
    bankAccountCurrency: 'Сurrency',
    bankAccountNumber: 'Account number',
    sortCode: 'Sort code',
    edit: 'Edit',
    ukCountry: 'UK',
});
